// Public surface for the LLM library.
//
// Plug-and-play architecture:
//   1. User picks a provider, supplies an API key + model name in
//      Chat tab settings.
//   2. Settings persist to localStorage via settings.ts.
//   3. Chat tab calls runChat() with the conversation + dashboard.
//   4. runChat() builds the system prompt from the live dataset and
//      dispatches to the chosen provider.
//
// Adding a fourth provider is mechanical: implement the LlmProvider
// interface in providers.ts, register it in PROVIDERS, and add an
// option to the Chat settings dropdown.

export type {
  ChatMessage,
  ChatRequest,
  ChatResponse,
  ChatRole,
  LlmProvider,
  LlmProviderId,
  LlmSettings,
} from "./types";
export { LlmError } from "./types";

export { PROVIDER_LIST, PROVIDERS, getProvider } from "./providers";
export { isConfigured } from "./settings";
export { buildSystemPrompt } from "./context";

import type { ChatMessage, ChatResponse, LlmSettings } from "./types";
import { getProvider } from "./providers";
import { buildSystemPrompt } from "./context";
import type { Dataset } from "../types";

export async function runChat(
  messages: ChatMessage[],
  settings: LlmSettings,
  data: Dataset
): Promise<ChatResponse> {
  const provider = getProvider(settings.provider);
  const system = buildSystemPrompt(data);
  return provider.complete({ messages, system }, settings);
}
